module.exports = __webpack_public_path__ + "img/angle_210.3223e720.jpg";